import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Buefy from 'buefy';
import './registerServiceWorker';
import 'buefy/lib/buefy.css';

Vue.use(Buefy);
Vue.config.productionTip = false;

const $ = require('jquery');
window.$ = $;

// Global Components
import NavBar from '@/components/NavBar';


Vue.component('NavBar', NavBar);


new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
